var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.522 8.92a.503.503 0 0 0-.333-.614.45.45 0 0 0-.123-.018h-8.12a.12.12 0 0 1-.118-.1l-.27-1.36c-.153-.75-.779-1.286-1.505-1.29-.326 0-.591.28-.591.625s.265.625.591.625c.168 0 .313.126.347.3l1.5 7.534c.077.387.285.73.585.966a.13.13 0 0 1 .006.194 1.04 1.04 0 0 0-.097 1.41.912.912 0 0 0 1.336.103 1.04 1.04 0 0 0 .229-1.201.131.131 0 0 1 .005-.122.117.117 0 0 1 .1-.059h2.827c.065 0 .118.056.118.125a.133.133 0 0 1-.012.056c-.232.495-.04 1.094.428 1.34.13.068.274.103.42.103.522 0 .946-.448.946-1 0-.156-.035-.31-.102-.45a.123.123 0 0 1 .05-.161.11.11 0 0 1 .052-.014c.327 0 .592-.28.592-.625 0-.344-.265-.625-.592-.625h-5.386a.361.361 0 0 1-.347-.297l-.085-.427a.125.125 0 0 1 .116-.15h5.091c.64 0 1.202-.453 1.37-1.106l.972-3.762z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.28f954021404afce638e4aeadf1023d9.svg";
export { ForwardRef as ReactComponent };